module.exports = __webpack_public_path__ + "static/thomaspierrain-4701e5b417967efa3d8a34aee365e2e8.png";